<template>
  <div class="quote-breakdown">
    <ul v-if="ratebookEnabled" class="quote-breakdown-ratebook">
      <li>
        <span class="label">
          Average Monthly BiK
          <VDropdown>
            <span class="tooltip-info">?</span>
            <template #popper>
              <div class="popper-content">
                <h6>Monthly Benefit in Kind (BiK)</h6>
                <ul class="plain striped">
                  <li v-for="bik in RatebookHelper.bikAmounts(ratebook)">
                    <span>Tax year end - {{ bik.year }}</span>
                    <span>£{{ bik.amount }}</span>
                  </li>
                </ul>
              </div>
            </template>
          </VDropdown>
        </span>
        <span class="value">£{{ RatebookHelper.averageMonthlyBik(ratebook, term)}}</span>
      </li>
      <li v-if="RatebookHelper.tradeUpDownRawValue(ratebook)">
        <span class="label">
          Trade
          <template v-if="RatebookHelper.tradeUpDownRawValue(ratebook) < 0">Down</template>
          <template v-else>Up</template>
        </span>
        <span class="value">£{{RatebookHelper.tradeUpDown(ratebook, term)}}</span>
      </li>
      <li v-if="RatebookHelper.oneOffContribution(ratebook, term)" :class="{'has-remaining':currentProduct.your_shortlist_display_remaining_grade_level_budget && oocRemaining}">
        <span class="label">One-Off Contribution</span>
        <span class="value">£{{ RatebookHelper.oneOffContribution(ratebook, term) }}</span>
      </li>
      <li v-if="currentProduct.your_shortlist_display_remaining_grade_level_budget && oocRemaining !== null" class="ratebook-remaining" :class="{'over': oocRemaining < 0}">
        <span class="label"></span>
        <span class="value">
          Remaining One-off Contribution Budget: £{{oocRemaining.toFixed(2)}}
        </span>
      </li>
      <li v-if="RatebookHelper.netCost(ratebook, term)" class="ratebook-netcost">
        <span class="label">
          Estimated NET Monthly Cost
          <VDropdown>
            <span class="tooltip-info white">?</span>
            <template #popper>
              <div class="popper-content">
                <p>This cost is the average monthly BIK, plus the cost of any <br>
                  one-off contribution spread over the contract duration. As per <br>
                  the policy, the one-off contribution will need to be paid in full <br>
                  before the vehicle is delivered.</p>
              </div>
            </template>
          </VDropdown>
        </span>
        <span class="value">£{{ RatebookHelper.netCost(ratebook, term) }}</span>
      </li>
      <!--Use jaama rental price as per Chris Paddick 12/6/25-->
      <li v-if="currentProduct.your_shortlist_display_vehicle_rental_cost" class="ratebook-othercost">
        <span class="label">Vehicle Rental</span>
        <span class="value">£{{ activeQuote.details.pricing.totalExVAT }}<!--{{ RatebookHelper.vehicleRental(ratebook, term) }}--></span>
      </li>
      <li v-if="currentProduct.your_shortlist_display_estimated_whole_life_cost && RatebookHelper.wholeLifeCost(ratebook, term)" class="ratebook-othercost" :class="{'has-remaining':currentProduct.your_shortlist_display_remaining_grade_level_budget && wlcRemaining}">
        <span class="label">Whole Life Cost</span>
        <span class="value">£{{ RatebookHelper.wholeLifeCost(ratebook, term) }}</span>
      </li>
      <li v-if="currentProduct.your_shortlist_display_remaining_grade_level_budget && wlcRemaining !== null" class="ratebook-remaining" :class="{'over': wlcRemaining < 0}">
        <span class="label"></span>
        <span class="value">
          Remaining Whole Life Cost Budget: £{{wlcRemaining.toFixed(2)}}
        </span>
      </li>
    </ul>
    <ul v-else class="quote-breakdown-list-bch quote-breakdown-list">
      <li>
        <span class="cost">
          <span class="label">Monthly BiK</span>
          <span class="value">£{{ monthlyBik }}</span>
        </span>
      </li>
      <li v-if="costConfiguration.showContribution === 'monthly'">
        <span class="cost">
          <span class="label">Monthly Contribution</span>
          <span class="value">//TODO</span>
        </span>
      </li>
      <li v-if="costConfiguration.showRental === 'totaleffective'">
        <span class="cost">
          <span class="label">Vehicle Rental</span>
          <span class="value">£{{ activeQuote.details.lifeCosts.totalEffectiveRental }}</span>
        </span>
      </li>
      <li v-if="costConfiguration.showRental === 'rentalexvat'">
        <span class="cost">
          <span class="label">Vehicle Rental</span>
          <span class="value">£{{ activeQuote.details.pricing.totalExVAT }}</span>
        </span>
      </li>
      <li v-if="costConfiguration.showContribution === 'oneoff'">
        <span class="cost">
          <span class="label">One Off Contribution</span>
          <span class="value">//TODO</span>
        </span>
      </li>
      <li class="comparison-divider"></li>
      <li>
        <span class="cost total">
          <span class="label">Total Monthly Cost</span>
          <span class="value">£{{ monthlyCost }}</span>
        </span>
      </li>
      <li class="comparison-divider"></li>
    </ul>

    <template v-if="ratebookDebug">
      <h5>Ratebook Data:</h5>
      <ul class="ratebook">
        <li v-for="(item, index) in ratebook" :key="index" style="padding:5px;border-bottom:1px solid #333;">
          <template v-if="index !== 'requestJSON'">
            <span>{{ index }}: </span>
            <ul v-if="typeof item === 'object' && item !== null">
              <li v-for="(subItem, subIndex) in item" :key="subIndex">
                <span>{{ subIndex }}: </span>
                <span><b>{{ subItem === null ? 'NULL' : subItem }}</b></span>
              </li>
            </ul>
            <span v-else><b>{{ item === null ? 'NULL' : item }}</b></span>
          </template>
        </li>
      </ul>
    </template>
  </div>

</template>

<script type="text/javascript">

import LoadingIcon from "@/components/loading-icon";
import VehicleCosts from '@/helpers/vehicle-costs';
import {useRoute} from "vue-router";
import RatebookHelper from "@/helpers/ratebook";

export default {
  name: 'bch-quote-breakdown',
  components: {LoadingIcon},
  props: [
    'quote',
    'derivative',
    'workingQuote',
    'quoteCosts',
    'driverProfile',
    'type',
    'showFuel',
    'showTraditionalCost',
    'orderSummaryView',
    'averagePencePerMile',
    'totalEstimatedElectricCostPerMonth',
    'adminPortalData',
  ],
  data() {
    return {
      ratebookDebug: false,
    }
  },
  setup() {
    const route = useRoute()
    return {route}
  },

  mounted() {
  },

  created() {
    this.getVehicleBikByRate = VehicleCosts.getVehicleBikByRate;
  },
  computed: {
    RatebookHelper() {
      return RatebookHelper
    },
    // A basic, non-definitive way of checking if a user has a ratebook for this vehicle, and thus should see the ratebook values
    ratebook() {
      return this.quote.taxCalculations;
    },
    ratebookEnabled() {
      return this.RatebookHelper.isRatebookEnabledGrade(this.quote.details.driverGradeName);
    },
    driverGrade() {
      return this.quote.driverGrade;
    },
    term() {
      return this.quote.definition.plan.term;
    },
    activeQuote() {
      return this.workingQuote ? this.workingQuote : this.quote;
    },
    monthlyBik() {
      return Number(this.getVehicleBikByRate(this.activeQuote.details, this.driverProfile.incomeTaxBand.ratePercent)).toFixed(2);
    },
    costConfiguration() {
      return {
        showContribution: this.productData.display_settings_show_monthly_contribution ? this.productData.display_settings_monthly_contribution_type : false,
        showRental: this.productData.display_settings_show_vehicle_rental ? this.productData.display_settings_vehicle_rental_type : false,
      }
    },
    productData() {
      return this.adminPortalData.content.products['bch'][0];
    },
    monthlyCost() { //TODO
      let cost = parseFloat(this.monthlyBik);
      if (this.costConfiguration.showContribution === 'monthly') {
        cost += 0; //TODO
      }
      return cost.toFixed(2);
    },
    currentProduct() {
      return this.adminPortalData.content.products['bch'][0];
    },
    showBchWlc() {
      return RatebookHelper.showWholeLifeCosts(this.currentProduct);
    },
    showBchVehicleRental() {
      return RatebookHelper.showVehicleRental(this.currentProduct);
    },
    oocRemaining() {
      console.log(this.quote);
      return this.RatebookHelper.oneOffContributionRemaining(this.ratebook, this.driverGrade.deloitteFilters.employeeCostCapitalContributionTo, this.term);
    },
    wlcRemaining() {
      return this.RatebookHelper.wholeLifeCostRemaining(this.ratebook, this.driverGrade.deloitteFilters.companyCostTotalTo, this.term);
    },
  },
  methods: {
    getMonthlyCost(value) {
      return (Number(value) / this.term);
    },

    getInCurrency(value, currency = "£") {
      return currency + Number(value).toFixed(2);
    }

  }
}
</script>

<style scoped lang="scss">
ul.quote-breakdown-list-bch {
  float: none;
  width: 100%;

  li {
    width: 100%;
    display: block;
    margin-bottom: 6px;

    &:nth-child(even) {
      padding-left: 0;
    }

    &:nth-child(odd) {
      padding-right: 0;
    }

    &.comparison-divider {
      border-top: 1px solid #C8D9DE;
      border-bottom: 1px solid #C8D9DE;
      margin-top: 20px !important;
      margin-bottom: 20px !important;
    }
  }

  span.cost {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    span {
      &.label {
        font-size: 14px;
      }

      &.value {
        font-size: 18px !important;
      }
    }

    &.total {
      span.label {
        font-weight: bold;
        font-size: 16px;
      }

      span.value {
        font-weight: bold;
      }
    }
  }
}
</style>
